import { Modal, ModalWithTransition } from '@studiometa/ui';

/**
 * Facets component
 */
export default class Search extends ModalWithTransition {
  timeout = null;

  /**
   * Component Configuration
   */
  static config = {
    name: 'Search',
    refs: [...Modal.config.refs, 'form', 'input', 'results', 'loader'],
    options: {
      styles: {
        type: Object,
        /**
         * @returns {ModalStylesOption}
         */
        default: () => ({
          modal: {
            closed: 'pointer-events-auto -translate-y-full',
            active: 'transition duration-700 ease-out-expo',
          },
          overlay: {
            closed: 'opacity-0',
            active: 'transition duration-700 ease-out-expo',
          },
          container: {
            closed: 'transform opacity-0',
            active: 'transition duration-700 ease-out-expo',
          },
        }),
      },
    },
  };

  /**
   *
   */
  mounted() {
    this.defaultResults = this.$refs.results.innerHTML;
    super.mounted();
  }

  /**
   * Get input value
   * @returns {string} current value.
   */
  get searchTerm() {
    return this.$refs.input.value;
  }

  /**
   * Perform search when typing something in input
   * @returns {void}
   */
  onInputInput() {
    this.$refs.loader.style.display = 'block';

    clearTimeout(this.timeout);

    if (!this.searchTerm) {
      this.$refs.loader.style.display = 'none';
      this.$refs.results.innerHTML = this.defaultResults;
      return;
    }

    this.timeout = setTimeout(() => {
      fetch(
        `${window.routes.predictive_search_url}?q=${encodeURIComponent(this.searchTerm)}&section_id=predictive-search&resources[type]=product&resources[options][fields]=title,body,variants.title`,
      )
        .then((response) => {
          if (!response.ok) {
            const error = new Error(response.status);
            throw error;
          }

          return response.text();
        })
        .then((text) => {
          const results = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#shopify-section-predictive-search').innerHTML;

          this.renderResults(results);
          this.initAllResultsBtn();
        })
        .catch((error) => {
          if (error?.code === 20) {
            // Code 20 means the call was aborted
            return;
          }
          throw error;
        });
    }, 400);
  }

  /**
   *
   */
  initAllResultsBtn() {
    this.$el.querySelector('#all-results').addEventListener('click', () => {
      this.$refs.form.requestSubmit();
    });
  }

  /**
   * Set results to the page
   * @param  {HTML} results products results
   * @returns {void}
   */
  renderResults(results) {
    this.$refs.loader.style.display = 'none';
    this.$refs.results.innerHTML = results;
  }
}
